<!-- <div class="limiter">
  <div class="container-login100">
    <div class="wrap-login100">
      <form class="login100-form validate-form" [formGroup]="login_page" (ngSubmit)="logIn()">
        <span class="login100-form-title p-b-45">
          Login
        </span>


        <div class="wrap-input100 validate-input" data-validate="User Name is required">
          <input class="input100" type="text" name="username" formControlName="user_name">
          <span class="focus-input100"></span>
          <span class="label-input100">User Name</span>
        </div>


        <div class="wrap-input100 validate-input" data-validate="Password is required">
          <input class="input100" type="password" name="pass" formControlName="password">
          <span class="focus-input100"></span>
          <span class="label-input100">Password</span>
        </div>

        <div class="flex-sb-m w-full p-t-15 p-b-20">
        </div>

        <div class="container-login100-form-btn">
          <button class="login100-form-btn">
            Login
          </button>
        </div>

      </form>

      <div class="login100-more" style="background-image: url('assets/images/login_page.png');">
      </div>
    </div>
  </div>
</div> -->

<div class="container-fluid" style="width: 100; height: 100;">
  <div class="row">
    <div class="col">
      <div class="contaner-fluid"></div>

    </div>
    <div class="col">
      <div class="contaner align-middle login">
        <mat-card style="margin-top: 30%;">
          <form [formGroup]="login_form">
            <div class="form-group">
              <label for="exampleInputEmail1">User Name</label>
              <input type="text" class="form-control" formControlName='user_name' id='user_name'
                (keydown.enter)="focusToPassword()">
            </div>
            <div class="form-group">
              <label for="exampleInputPassword1">Password</label>
              <input type="password" class="form-control" formControlName='password' id='password'>
            </div>
            <button style="margin-left: 40%;" mat-raised-button color="priary" (click)="logIn()">Login</button>
          </form>
        </mat-card>
      </div>
    </div>
  </div>

</div>
